(ns storrito.connect3.select-verify-method-panel
  (:require [storrito.ui.button :as button]
            [storrito.connect3.common :as common]
            ))

(def enum->verification-method
  "Convert enum to name"
  {"0" "SMS"
   "1" "EMAIL"
   "2" "Backup Code"
   "3" "Authenticator App"
   "6" "Whats App"})

(defn selected-method
  "The verification method enum that is currently selected: the user's radio
   choice, falling back to Instagram's default option, then phone, then email.
   Instagram sometimes sends the default choice as a number, so it is
   normalized to the string enum the radios and connect.php work with."
  [state]
  (or (:verification-method state)
      (some-> (:default state) str)
      (when (:phone_number state) "0")
      (when (:email state) "1")))

(defn panel
  [state]
  (let [phone (:phone_number state)
        mail (:email state)
        default (some-> (:default state) str)
        selected (selected-method state)
        on {:input [[:store/assoc-in [:connect3 :verification-method] :event/target.value]]}]
    [:div.mt-4
     (common/instagram-logo)

     [:div.text-center.mb-5
      [:h2.font-bold.text-2xl.text-center.pl-5.pr-5
       "Please select a verification method"]]

     [:div.flex.flex-col.items-center
      (when mail
        [:label.inline-flex.items-center.mt-1
         {:style {:cursor "pointer"}}
         [:input.h-5.w-5.text-gray-600
          {:type "radio"
           :name "2fa-method"
           :checked (= selected "1")
           :value "1"
           :on on}]
         [:span.ml-2.text-gray-700 mail]])

      (when phone
        [:label.inline-flex.items-center.mt-3
         {:style {:cursor "pointer"}}
         [:input.h-5.w-5.text-gray-600
          {:type "radio"
           :name "2fa-method"
           :checked (= selected "0")
           :value "0"
           :on on}]
         [:span.ml-2.text-gray-700 phone]])

      (when (and default
                 (> (js/parseInt default)
                    1))
        [:label.inline-flex.items-center.mt-3
         {:style {:cursor "pointer"}}
         [:input.h-5.w-5.text-gray-600
          {:type "radio"
           :name "2fa-method"
           :checked (= selected default)
           :value default
           :on on}]
         [:span.ml-2.text-gray-700 (enum->verification-method default)]])

      (button/button-primary
        {:class "mt-3"
         ;; connect.php reads the reply under "verification-method"
         ;; (handleExceptions.php, select-verify-method case), so the
         ;; selected enum must be sent under exactly that key:
         :on {:click [[:connect3/send! {:verification-method selected}]]}}
        "Send Verification Code")]]))
